import { Location } from '@angular/common';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ApiService } from 'src/app/services/api.service';
import { ErrorType } from 'src/app/enums/error-type.enum';
import { MatSelectChange } from '@angular/material/select';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import endpoints from 'src/app/helpers/endpoints';

@Component({
  selector: 'fury-plan-price-add-edit',
  templateUrl: './plan-price-add-edit.component.html',
  styleUrls: ['./plan-price-add-edit.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class PlanPriceAddEditComponent implements OnInit, OnDestroy {
  planPriceId: string = '';
  planpropertyPrice!: FormGroup;
  planCoverItems: any = [];
  planSizeOption: any = [];
  planTypeOption: any = [];
  dynamicForm!: FormGroup;
  covererItems :any[]= [];
  isView = false;
  ngUnsubscribe = new Subject<void>();
  constructor(
    public location: Location,
    public api: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    ) {
    this.activatedRoute.params.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      this.planPriceId = res?.id;
      if (this.planPriceId) this.getDetails();
    });
   }

  ngOnInit(): void { 
    this.formInIt(); 
    this.dynamicForm = this.fb.group({});
    this.isView = this.router.url.includes('view-plan-price');
    if(this.isView) {
      this.planpropertyPrice.disable(); 
    }
    this.loadEverything();
  }
  loadEverything() {
    this.api.get(`${endpoints.planManagement.planPrice.getOptionalItems}?page=1&size=9999&type=main`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: HttpResponse<any>) => {
      if (res && res['body']['planOptionalItemCategories']) this.planCoverItems = res['body']['planOptionalItemCategories']['data']
    });
    this.api.get(`${endpoints.common.getPropertyType}?page=1&size=9999`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: HttpResponse<any>) => {
      if (res && res['body']['planPropertyTypes']) this.planTypeOption = res['body']['planPropertyTypes']['data']
    });
    this.api.get(`${endpoints.common.getPropertySize}?page=1&size=9999`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: HttpResponse<any>) => {
      if (res && res['body']['planPropertySizes']) this.planSizeOption = res['body']['planPropertySizes']['data']
    });
  }
  getDetails(){
    this.api.get(endpoints.planManagement.planPrice.getPlanPrice(this.planPriceId)).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      if (res.status === 200) {
        this.dynamicForm = this.fb.group({});
        const rawData = res.body.planPrice;
        this.planpropertyPrice.patchValue(rawData);
        this.planpropertyPrice.get('plan_property_type_id').setValue(rawData['plan_property_type']['planPropertyTypeId']);
        this.planpropertyPrice.get('plan_property_size_id').setValue(rawData['plan_property_size']['planPropertySizeId']);
        this.planpropertyPrice.get('plan_optional_item_category_id').setValue(rawData['plan_optional_item_category']['planOptionalItemCategoryId']);

        if(rawData.coveredItems?.length > 0){
          const convertData = rawData.coveredItems.map(item => ({
            planCoverItemId: item.coveredItems?.planCoverItemId,
            title: item.coveredItems?.title,
            quantity: item?.quantity,
            orderNumber: item?.orderNumber,
          }));
          this.covererItems = convertData;
        } else {
          this.covererItems = rawData?.plan_optional_item_category.coveredItems;
        };
        this.covererItems.forEach(item =>{
          const validators = [Validators.required, Validators.min(1)];
          const control = this.fb.control(item?.quantity || 1 , validators);
          const orderControl = this.fb.control(item?.orderNumber || 1 , validators);
          this.dynamicForm.addControl(item?.planCoverItemId+'-orderNumber', orderControl);
          this.dynamicForm.addControl(item?.planCoverItemId, control);
        })
        if(this.isView)  this.dynamicForm.disable();

      }
    }, err => { });
  }
  formInIt() {
    this.planpropertyPrice = new FormGroup({
      plan_property_type_id: new FormControl('', [Validators.required]),
      plan_property_size_id: new FormControl('', [Validators.required]),
      plan_optional_item_category_id: new FormControl('', [Validators.required]),
      displayMonthlyPrice: new FormControl('', [Validators.required]),
      discountedMonthlyPrice: new FormControl('', [Validators.required]),
      displayYearlyPrice: new FormControl('', [Validators.required]),
      discountedYearlyPrice: new FormControl('', [Validators.required]),
      displayTwoYearlyPrice: new FormControl('', [Validators.required]),
      discountedTwoYearlyPrice: new FormControl('', [Validators.required]),
      displayThreeYearlyPrice: new FormControl('', [Validators.required]),
      discountedThreeYearlyPrice: new FormControl('', [Validators.required]),
      displayFourYearlyPrice: new FormControl('', [Validators.required]),
      discountedFourYearlyPrice: new FormControl('', [Validators.required]),
      displayFiveYearlyPrice: new FormControl('', [Validators.required]),
      discountedFiveYearlyPrice: new FormControl('', [Validators.required]),
      monthlyFreeMonth: new FormControl('', [Validators.required, Validators.min(0), Validators.max(12)]),
      annuallyFreeMonth: new FormControl('', [Validators.required, Validators.min(0), Validators.max(12)]),
      twoYearsFreeMonth: new FormControl('', [Validators.required, Validators.min(0), Validators.max(12)]),
      threeYearsFreeMonth: new FormControl('', [Validators.required, Validators.min(0), Validators.max(12)]),
      fourYearsFreeMonth: new FormControl('', [Validators.required, Validators.min(0), Validators.max(12)]),
      fiveYearsFreeMonth: new FormControl('', [Validators.required, Validators.min(0), Validators.max(12)]),
      monthlyMaximumDiscount: new FormControl('', [Validators.required, Validators.min(0)]),
      yearlyMaximumDiscount: new FormControl('', [Validators.required, Validators.min(0)]),
      twoYearsMaximumDiscount: new FormControl('', [Validators.required, Validators.min(0)]),
      threeYearsMaximumDiscount: new FormControl('', [Validators.required, Validators.min(0)]),
      fourYearsMaximumDiscount: new FormControl('', [Validators.required, Validators.min(0)]),
      fiveYearsMaximumDiscount: new FormControl('', [Validators.required, Validators.min(0)]),
    });
  };
  planTypeChange(event: MatSelectChange){
    this.dynamicForm = this.fb.group({});
    this.covererItems = [];
    if(event.value){
      this.api.get(endpoints.planManagement.planPrice.getOptionalItemCategories(event.value)).pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: HttpResponse<any>)=>{
        this.covererItems = res.body?.planOptionalItemCategory?.coveredItems;
        this.covererItems.forEach(item =>{
          const validators = [Validators.required, Validators.min(1)];
          const control = this.fb.control(1 , validators);
          const orderControl = this.fb.control(item?.orderNumber || 1 , validators);
          this.dynamicForm.addControl(item?.planCoverItemId+'-orderNumber', orderControl);
          this.dynamicForm.addControl(item?.planCoverItemId, control);
        })
      })
    }
  }
  Save() {
    if (this.planpropertyPrice.valid && this.dynamicForm.valid) {
      const convertData = Object.keys(this.dynamicForm.value)
        .filter((key) => !key.includes("-orderNumber"))
        .map((key) => ({
          itemId: key,
          quantity: this.dynamicForm.value[key],
          order: this.dynamicForm.value[`${key}-orderNumber`],
        }));
      const rawData = this.planpropertyPrice.getRawValue();
      rawData.coveredItemIds = convertData;
      const url = this.planPriceId ? this.api.patch(endpoints.planManagement.planPrice.updatePlanPrice(this.planPriceId), rawData) :
        this.api.post(endpoints.planManagement.planPrice.createPlanPrice, rawData);
      url.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.status === 201) {
            this.router.navigate(['/plan-management/plan-price/plan-price-list'])
            this.api.alert(res.body.message, ErrorType.Success);
          } else if(res.status === 200) {
            this.router.navigate(['/plan-management/plan-price/plan-price-list'])
            this.api.alert(res.body.message, ErrorType.Success);
          } else {
            this.api.alert(res.body.message, ErrorType.Warning);
          }
        }, error: (err: HttpErrorResponse) => { if (err) this.api.alert(err.message, ErrorType.Error) }
      });
    } else {
      this.planpropertyPrice.markAllAsTouched();
      this.dynamicForm.markAllAsTouched();
    }
  }
  back() { this.location.back() }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
